import React, { useEffect, useState } from 'react';
import '~/components/CobuTable/CobuTable.css';

const PAGE_SIZES = [10, 20, 30, 40, 50];

type Props = {
  page: number;
  pageCount: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};

// 1-based pager for lists paged by the server.
const ServerPagination = ({
  page,
  pageCount,
  pageSize,
  onPageChange,
  onPageSizeChange
}: Props) => {
  // Typed text for "Go to page"; applied on Enter or blur, not per keystroke.
  const [pageInput, setPageInput] = useState(String(page));

  useEffect(() => {
    setPageInput(String(page));
  }, [page]);

  const goTo = (p: number) => onPageChange(Math.min(Math.max(p, 1), pageCount));
  const applyPageInput = () => {
    const target = Math.min(Math.max(Number(pageInput) || page, 1), pageCount);
    onPageChange(target);
    setPageInput(String(target));
  };

  return (
    <div style={{ margin: '24px 0 50px' }}>
      <div className='pagination'>
        <button onClick={() => goTo(1)} disabled={page === 1}>
          {'<<'}
        </button>
        <button onClick={() => goTo(page - 1)} disabled={page === 1}>
          {'<'}
        </button>
        <button onClick={() => goTo(page + 1)} disabled={page === pageCount}>
          {'>'}
        </button>
        <button onClick={() => goTo(pageCount)} disabled={page === pageCount}>
          {'>>'}
        </button>
        <span style={{ marginRight: '10px', marginLeft: '10px' }}>
          Page
          <strong>
            {page} of {pageCount}
          </strong>
        </span>
      </div>
      <div className='pagination'>
        <span>
          Go to page:
          <input
            type='number'
            min={1}
            max={pageCount}
            value={pageInput}
            onChange={(e) => setPageInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && applyPageInput()}
            onBlur={applyPageInput}
            style={{
              width: '100px',
              marginRight: '10px',
              marginLeft: '10px'
            }}
          />
        </span>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {PAGE_SIZES.map((size) => (
            <option key={size} value={size}>
              Show {size}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ServerPagination;
